<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Swal },
    data() {
        return {
            title: "Evaluaciones Laborantes",
            items: [
                {
                text: "Evaluaciones",
                href: "/web/evaluaciones/evaluaciones_laborantes"
                },
                {
                text: "Evaluar Laborante",
                active: true
                }
            ],
            usuarios:[],
            laborantes:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            dato:{
                id:'',
                coordinador:'',
                tipo_laborante:'',
                evaluacion_id:'',
                p1:'¿Es responsable en el cumplimiento de horarios y actividades agendadas?',
                r1:'',
                p2:'¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?',
                r2:'',
                p3:'¿Maneja información relevante de la Universidad, Oferta Académica, Postulación, Becas, entre otros,  para entregar a los estudiantes cuando se le solicita?',
                r3:'',
                p4:'¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?',
                r4:'',
                p5:'',
                r5:'',
            },
            encuestasPorTipo: {
                default: {
                    p1: '¿Es responsable en el cumplimiento de horarios y actividades agendadas?',
                    p2: '¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?',
                    p3: '¿Maneja información relevante de la Universidad, Oferta Académica, Postulación, Becas, entre otros, para entregar a los estudiantes cuando se le solicita?',
                    p4: '¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?'
                },
                relator: {
                    p1: '¿Es responsable en el cumplimiento de horarios y actividades agendadas?',
                    p2: '¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?',
                    p3: '¿Maneja información relevante de la Universidad, Oferta Académica, Postulación, Becas, entre otros, para entregar a los estudiantes cuando se le solicita?',
                    p4: '¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?'
                },
                apoyo: {
                    p1: '¿Es responsable en el cumplimiento de horarios y actividades agendadas?',
                    p2: '¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?',
                    p3: '¿Maneja información relevante de la Universidad, Oferta Académica, Postulación, Becas, entre otros, para entregar a los estudiantes cuando se le solicita?',
                    p4: '¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?'
                },
                digitalizador: {
                    p1: '¿Respeta los plazos estipulados para el término de la actividad, ya sea apoyo de oficina, armado de maletas, etc.?',
                    p2: '¿Maneja información general de la Universidad y es capaz de resolver dudas de los estudiantes mientras su compañero realiza la charla?',
                    p3: '¿Cumple con los horarios de citación para las actividades en las que se registra?',
                    p4: '¿Su presentación personal es acorde con el estándar institucional y con la actividad realizada?',
                    p5: '¿Muestra disposición e iniciativa al momento de trabajar en equipo?'
                },
                salida: {
                    p1: '¿Respeta los plazos estipulados para el término de la actividad, ya sea apoyo de oficina, armado de maletas, etc.?',
                    p2: '¿Maneja información general de la Universidad y es capaz de resolver dudas de los estudiantes mientras su compañero realiza la charla?',
                    p3: '¿Cumple con los horarios de citación para las actividades en las que se registra?',
                    p4: '¿Su presentación personal es acorde con el estándar institucional y con la actividad realizada?',
                    p5: '¿Muestra disposición e iniciativa al momento de trabajar en equipo?'
                },
                apoyo_oficina: {
                    p1: '¿Respeta los plazos estipulados para el término de la actividad, ya sea apoyo de oficina, armado de maletas, etc.?',
                    p2: '¿Maneja información general de la Universidad y es capaz de resolver dudas de los estudiantes mientras su compañero realiza la charla?',
                    p3: '¿Cumple con los horarios de citación para las actividades en las que se registra?',
                    p4: '¿Su presentación personal es acorde con el estándar institucional y con la actividad realizada?',
                    p5: '¿Muestra disposición e iniciativa al momento de trabajar en equipo?'
                }
            },
            ordenEstado: null,
        };
    },
    computed:{
        rows() {
            return this.laborantes.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            let resultado = this.laborantes.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    this.obtenerTipoLaborante(item).toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
            if (this.ordenEstado) {
                resultado.sort((a, b) => {
                    const estadoA = a.fecha_respuesta == null ? 0 : 1;
                    const estadoB = b.fecha_respuesta == null ? 0 : 1
                    return this.ordenEstado === 'asc'
                        ? estadoA - estadoB
                        : estadoB - estadoA;
                });
            }
            return resultado;
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        showModal(item) {
            this.dato.coordinador = item.name;
            this.dato.tipo_laborante = this.obtenerTipoLaborante(item);
            this.aplicarEncuestaPorTipo(this.dato.tipo_laborante);
            this.dato.id = item.user_id;
            this.dato.evaluacion_id = item.evaluacion_id;
            this.dato.r1 = item.r1;
            this.dato.r2 = item.r2;
            this.dato.r3 = item.r3;
            this.dato.r4 = item.r4;
            this.$refs['modal-evaluar'].show()
        },
        obtenerTipoLaborante(item) {
            return item.tipo_laborante || item.cargo || item.tipo_laborante_nombre || '-';
        },
        normalizarTipoLaborante(tipo) {
            const valor = (tipo || '').toString().toLowerCase().trim();
            if (valor.includes('relator')) return 'relator';
            if (valor.includes('digitalizador')) return 'digitalizador';
            if (valor.includes('salida')) return 'salida';
            if (valor.includes('apoyo oficina')) return 'apoyo_oficina';
            if (valor.includes('apoyo')) return 'apoyo';
            return 'default';
        },
        aplicarEncuestaPorTipo(tipo) {
            const clave = this.normalizarTipoLaborante(tipo);
            const encuesta = this.encuestasPorTipo[clave] || this.encuestasPorTipo.default;
            this.dato.p1 = encuesta.p1;
            this.dato.p2 = encuesta.p2;
            this.dato.p3 = encuesta.p3;
            this.dato.p4 = encuesta.p4;
        },
        mes_ano(mes_actual){
            const [mes, ano] = mes_actual.split('-');
            // Crear una fecha (día 1 para evitar problemas)
            const fecha = new Date(ano, parseInt(mes, 10) - 1, 1);
            // Usar Intl.DateTimeFormat para obtener el nombre del mes en español
            const mesTexto = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(fecha);
            return mesTexto.charAt(0).toUpperCase() + mesTexto.slice(1); 
        },
        responder(){
            let formData = new FormData();
            formData.append('user_id', this.dato.id);
            formData.append('evaluacion_id', this.dato.evaluacion_id);
            formData.append('p1', this.dato.p1);
            formData.append('r1', this.dato.r1);
            formData.append('p2', this.dato.p2);
            formData.append('r2', this.dato.r2);
            formData.append('p3', this.dato.p3);
            formData.append('r3', this.dato.r3);
            formData.append('p4', this.dato.p4);
            formData.append('r4', this.dato.r4);
            axios.post('/api/guardar_evaluacion_laborante',formData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'success',
                        title: 'Se ha guardado la evaluación',
                        //text: '',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    axios.get('/api/get_evaluaciones_laborantes').then(res=>{
                        if (this.user.rol=='SuperAdmin' || this.user.rol=='Admin' || this.user.rol=='Supervisor') {
                            this.laborantes=res.data.laborantes;
                        }else if(this.user.rol=='Coordinador'){
                            this.laborantes = res.data.laborantes.filter((us)=>us.resp_id==this.user.id)
                        }
                    });
                }
            });
        },
        filtrar_coordinador(item){
            let user = this.usuarios.find(us=>us.id==item)
            return user.name
        },
        ordenarPorEstado() {
            if (this.ordenEstado === null) {
                this.ordenEstado = 'asc';
            } else if (this.ordenEstado === 'asc') {
                this.ordenEstado = 'desc';
            } else {
                this.ordenEstado = null;
            }
        }
    },
    created(){
        axios.get('/api/get_evaluaciones_laborantes').then(res=>{
            if (this.user.rol=='Admin' || this.user.rol=='Supervisor') {
                this.laborantes=res.data.laborantes;
            }else if(this.user.rol=='Coordinador'){
                this.laborantes = res.data.laborantes.filter((us)=>us.resp_id==this.user.id)
            }
        });
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-edit font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Evaluar Laborante</h5>
                            <small class="text-white" style="opacity:.8;">Completa la evaluación del laborante</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 10%;">Nº</th>
                                        <th style="width: 18%;">Nombre</th>
                                        <th style="width: 15%;">Rut</th>
                                        <th style="width: 15%;">Tipo laborante</th>
                                        <!-- <th style="width: 20%;">Evaluado por</th> -->
                                        <th style="width: 10%;">Mes</th>
                                        <th style="width: 17%; cursor: pointer;" @click="ordenarPorEstado">
                                            Estado
                                            <span v-if="ordenEstado === 'asc'">▲</span>
                                            <span v-else-if="ordenEstado === 'desc'">▼</span>
                                        </th>
                                        <th style="width: 15%;">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ obtenerTipoLaborante(item) }}</td>
                                        <!-- <td>{{ item.resp_id}}</td> -->
                                        <td>{{ mes_ano(item.mes_ano) }}</td>
                                        <td :class="item.fecha_respuesta == null ? 'pill pill-sm rojo' : 'pill pill-sm verde'">{{ item.fecha_respuesta==null? 'No respondido':'Contestado' }}</td>
                                        <td>
                                            <b-button @click="showModal(item)" variant="primary">Evaluar</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-evaluar" size="lg" :title="'Evaluar a '+this.dato.coordinador+(this.dato.tipo_laborante!='-' ? ' ('+this.dato.tipo_laborante+')' : '')" ok-title="Guardar" cancel-title="Cancelar" @ok="responder">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Preparación</label>
                                        <b-form-group :label="dato.p1" v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r1"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Presentación Personal</label>
                                        <b-form-group :label="dato.p2" v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r2"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Contenido</label>
                                        <b-form-group :label="dato.p3" v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r3"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Habilidades</label>
                                        <b-form-group :label="dato.p4" v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r4"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>